import React from "react";
import EnquiryHelper from "./EnquiryHelper";
export default function DetailEnquiry(props) {

  const { quoteNumber, finalAmount, deliverytotal, setFollowup, followUp, setConfirm, confirm, validator, packingcharge, insurance, storage, discount, validateFlag, percentValue, subTotalInit } = props;

  function confirmHandler(e) {
    const { value } = e.target;
    setConfirm(value);
  }

  // useEffect(() => {

  // }, [deliverytotal])


  const minDatevalue = EnquiryHelper.minDate(new Date())

  let newinitialdelivery = false
  if(subTotalInit === 0 || isNaN(subTotalInit) === true){
    newinitialdelivery = deliverytotal - discount
  }
  return (
    <section className="mt-3 sectionBorder">
      <div className="card-header custom_header">
        <h5>Enquiry Details</h5>
      </div>

      <div className="card-body">
        <div className="row">

          <div className="mb-3 col-3">
            <label className="form-label">Quotation Number</label>
            <input
              className="form-control"
              type="text"
              placeholder="Enter Quotation Number"
              value={quoteNumber}
              readOnly
            />
          </div>

          <div className="mb-3 col-3">
            <label className="form-label">Quotation Amount {deliverytotal}</label>
            <input
              className="form-control"
              placeholder="Enter Quotation Amount"
              value={deliverytotal}
              type="number"
              readOnly
            />
          </div>

          <div className="mb-3 col-3">
            <label className="form-label">Follow Up Date</label>
            <input
              className="form-control"
              type="date"
              value={followUp}
              min={minDatevalue}
              onChange={(e) => setFollowup(e.target.value)}
            />
            {(confirm == "YES" && !validateFlag.proceedjob) && validator.current.message(
              "Followup Date",
              followUp,
              "required",
              { className: "text-danger text-capitalize" }
            )}
          </div>

          <div className="mb-3 col-2">
            <label className="form-label mb-2 ms-2">Confirmed</label>
            <div className="enquiry-f_size ms-2">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="confirm"
                  id="inlineRadio1"
                  value="YES"
                  checked={
                    confirm && confirm == "YES" ? true : false
                  }
                  onClick={(e) => confirmHandler(e)}
                />
                <label class="form-check-label" htmlFor="inlineRadio1">
                  YES
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="confirm"
                  id="inlineRadio2"
                  value="NO"
                  onClick={(e) => confirmHandler(e)}
                />
                <label class="form-check-label" htmlFor="inlineRadio2">
                  No
                </label>
              </div>
            </div>
            {!validateFlag.requote &&
              validator.current.message(
                "Confirmed",
                confirm,
                "required",
                { className: "text-danger text-capitalize" }
              )}

          </div>
        </div>

        <div className="row">

          <div className="col-4">
            <h6><small>Packing</small> - {packingcharge || 0} AED</h6>
            <h6><small>Insurance</small> - {insurance?.insurance_amount || 0} AED</h6>
          </div>
          <div className="col-4">
            <h6><small>Storage</small> - {storage?.storage_amount || 0} AED</h6>
            <h6><small>Discount</small> - {discount || 0} AED ({percentValue || "0"} % )</h6>
          </div>

          <div className="col-4">

            <h6><small>Sub Total</small> - {subTotalInit || 0} AED</h6>
            <h6><small>Total</small> - {newinitialdelivery || finalAmount || deliverytotal || 0} AED</h6>

          </div>


        </div>

        {/* <div className="row justify-content-end">
            <div className="col-2">
              
            </div>
            <div className="col-3">
            
            </div>
          </div> */}

      </div>
    </section>
  )
}